<template>
  <div class="image-gallery">
    <div
      v-for="(image, index) in images"
      :key="index"
      class="image-gallery__item"
      @click="openLightbox(index)"
    >
      <img :src="image.src" :alt="image.alt || `Image ${index + 1}`" />
    </div>

    <!-- Lightbox -->
    <div v-if="lightboxOpen" class="lightbox" @click="closeLightbox">
      <button class="lightbox__close" @click.stop="closeLightbox">×</button>
      <button
        v-if="images.length > 1"
        class="lightbox__nav lightbox__nav--prev"
        @click.stop="prevImage"
      >
        ‹
      </button>
      <img
        :src="images[currentIndex].src"
        :alt="images[currentIndex].alt"
        class="lightbox__image"
        @click.stop
      />
      <button
        v-if="images.length > 1"
        class="lightbox__nav lightbox__nav--next"
        @click.stop="nextImage"
      >
        ›
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageGallery',
  props: {
    images: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      lightboxOpen: false,
      currentIndex: 0,
    };
  },
  methods: {
    openLightbox(index) {
      this.currentIndex = index;
      this.lightboxOpen = true;
      document.body.style.overflow = 'hidden';
    },
    closeLightbox() {
      this.lightboxOpen = false;
      document.body.style.overflow = '';
    },
    prevImage() {
      this.currentIndex =
        this.currentIndex === 0 ? this.images.length - 1 : this.currentIndex - 1;
    },
    nextImage() {
      this.currentIndex =
        this.currentIndex === this.images.length - 1 ? 0 : this.currentIndex + 1;
    },
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeydown);
  },
  beforeUnmount() {
    document.removeEventListener('keydown', this.handleKeydown);
  },
  created() {
    this.handleKeydown = (e) => {
      if (!this.lightboxOpen) return;
      if (e.key === 'Escape') this.closeLightbox();
      if (e.key === 'ArrowLeft') this.prevImage();
      if (e.key === 'ArrowRight') this.nextImage();
    };
  },
};
</script>

<style lang="scss" scoped>
$primary: #2563eb;
$border: #e2e8f0;

.image-gallery {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 1rem;

  &__item {
    cursor: pointer;
    overflow: hidden;
    border: 2px solid $border;
    transition: border-color 0.2s ease;

    &:hover {
      border-color: $primary;
    }

    img {
      width: 100%;
      height: 200px;
      object-fit: cover;
      transition: transform 0.3s ease;
    }

    &:hover img {
      transform: scale(1.05);
    }
  }
}

.lightbox {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;

  &__image {
    max-width: 90%;
    max-height: 90%;
    object-fit: contain;
  }

  &__close {
    position: absolute;
    top: 1rem;
    right: 1.5rem;
    background: none;
    border: none;
    color: white;
    font-size: 3rem;
    cursor: pointer;
    line-height: 1;
    padding: 0.5rem;
    transition: color 0.2s ease;

    &:hover {
      color: $primary;
    }
  }

  &__nav {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    color: white;
    font-size: 4rem;
    cursor: pointer;
    padding: 1rem;
    transition: color 0.2s ease;

    &:hover {
      color: $primary;
    }

    &--prev {
      left: 1rem;
    }

    &--next {
      right: 1rem;
    }
  }
}
</style>
